import withStorage from "../index.js";
export default function (createStore, createEvent, storage) {
    return function (defaultState, config) {
        var updated = createEvent();
        var store = withStorage(createStore, storage)(defaultState, config).on(updated, function (_, value) { return value; });
        addEventListener('storage', function (e) {
            e.key === config.key && updated(store.get(null));
        });
        return store;
    };
};
